export const formatToPascal = (roleString) => {
  if (!roleString) return ""; // Handle empty or undefined input
  return roleString
    .toLowerCase() // Convert to lowercase for consistent formatting
    .split(/[_\s]+/) // Split by underscores or spaces
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(" "); // Join with spaces
};
